import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { Location } from './models/Location.model';
import { Tenant } from './models/Tenant.model';

interface ActiveTenantLocationState {
    activeTenant: Tenant | undefined;
    activeLocation: Location | undefined;
}

const initialState: ActiveTenantLocationState = {
    activeTenant: undefined,
    activeLocation: undefined,
};

export const ActiveTenantLocationStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withComputed((store) => ({
        hasActiveTenant: computed<boolean>(() => store.activeTenant() !== undefined),
        hasActiveLocation: computed<boolean>(() => store.activeLocation() !== undefined),
    })),
    withMethods((store) => ({
        setActiveTenant(activeTenant: Tenant | undefined): void {
            if (activeTenant === undefined) {
                throw new Error('activeTenant undefined');
            }

            patchState(store, { activeTenant: activeTenant, activeLocation: undefined });
        },
        clearActiveTenant(): void {
            patchState(store, { activeTenant: undefined, activeLocation: undefined });
        },
        setActiveLocation(activeLocation: Location | undefined): void {
            if (activeLocation === undefined) {
                throw new Error('activeLocation undefined');
            }
            if (store.activeTenant() === undefined) {
                throw new Error('activeTenant undefined');
            }

            patchState(store, { activeLocation: activeLocation });
        },
        clearActiveLocation(): void {
            patchState(store, { activeLocation: undefined });
        },
    })),
);
